import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "./Projects_Fullscreen_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

const Projects_Fullscreen_Modal = ({ projectData,...props }) => {
  const data = [
    "/assets/images/home/our_services/client_horizontal_images/img1.jpeg",
    "/assets/images/home/our_services/client_horizontal_images/img2.jpeg",
    "/assets/images/home/our_services/client_verticle_images/img1.jpeg",
    "/assets/images/home/our_services/client_horizontal_images/img3.jpeg",
    "/assets/images/home/our_services/client_verticle_images/img3.jpeg",
    "/assets/images/home/our_services/client_horizontal_images/img4.jpeg",
    "/assets/images/home/our_services/client_verticle_images/img3.jpeg",
    "/assets/images/home/our_services/client_verticle_images/img4.jpeg",
  ];

  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleMainSliderClick = (direction) => {
    console.log("swiperInstance", swiperInstance, direction);

    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  return (
    <Modal
      className="Projects_Fullscreen_Modal"
      fullscreen={true}
      size="lg"
      {...props}
      centered
    >
      <Modal.Body>
        <div className="products_holder">
          <div className="container">
            <div className="top_div">
              <p className="project_name">
                {projectData?.projectName},{" "}
                <span className="location">{projectData?.location}</span>{" "}
              </p>

              <div className="close_icon_holder">
                <img
                  src="/assets/images/others/close.png"
                  className="close_img"
                  onClick={() => {
                    props?.onHide();
                  }}
                />
              </div>
            </div>

            <div className="row justify-content-center align-items-center me-0 ms-0">
              <div className="col-sm-12 col-12">
                <div className="left_side_div">
                  <div className="swiper_container">
                    <Swiper
                      pagination={{
                        dynamicBullets: true,
                        clickable: true,
                      }}
                      onSwiper={setSwiperInstance}
                      autoplay={{ delay: 300 }}
                      slidePrev={1}
                      className="mySwiper"
                      breakpoints={{
                        0: {
                          slidesPerView: 1,
                        },
                      }}
                    >
                      {projectData?.imgs?.map((item) => {
                        return (
                          <SwiperSlide>
                            <div className="project_img_div">
                              <img src={item} className="project_img" />
                            </div>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>
                </div>

                <div className="silder_btn">
                  <div
                    className="back_btn_holder"
                    onClick={() => handleMainSliderClick("prev")}
                  >
                    <div className="back_btn">
                      <FontAwesomeIcon
                        icon={faPlay}
                        flip="horizontal"
                        className="icon"
                      />
                    </div>
                  </div>
                  <div
                    className="back_btn_holder"
                    onClick={() => handleMainSliderClick("next")}
                  >
                    <div className="back_btn">
                      <FontAwesomeIcon icon={faPlay} className="icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Projects_Fullscreen_Modal;
